module.exports = __webpack_public_path__ + "media/images/360/narcolepsy_moon_mountains-3a19e566e921b4b0158c93bdfe567817.jpg";